import * as Sentry from '@sentry/react';
import { ArrowLeft } from 'lucide-react';
import { useEffect } from 'react';
import { Link, useRouteError } from 'react-router';

import { Button } from '../ui/button';

export const DemoViewerRouteErrorBoundary = () => {
  const error = useRouteError() as Error;

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex h-full items-center justify-center">
      <div className="text-center">
        <div className="mx-auto max-w-md space-y-3">
          <h1 className="text-8xl font-semibold">500</h1>
          <h2 className="whitespace-nowrap text-3xl font-medium tracking-tight">
            Unable to Load 2D Replay
          </h2>
          <p className="text-pretty text-muted-foreground">
            This demo may be corrupted or unavailable. Please try another demo
            or refresh the page. Contact support if the issue persists.
          </p>
          <Button size="sm" asChild>
            <Link to="/demo-viewer">
              <ArrowLeft size={16} />
              Back to Demo List
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};
